<qr-overlay-topbar (close)="close.emit()"
  >Detalle de la {{ title }}
</qr-overlay-topbar>
<!-- DETALLE RESERVA -->
<div class="preview" *ngIf="isReservation && reservation">
  <div class="preview__container">
    <div class="preview__item">
      <div class="preview__title">
        <p>Propiedad</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--address">
          <p class="preview__subtitle">Dirección</p>
          <p class="preview__info">{{ reservation.address }}</p>
        </div>
        <div class="preview__column preview__column--mls">
          <p class="preview__subtitle">MLS-ID</p>
          <p class="preview__info">{{ reservation.mlsId }}</p>
        </div>
      </div>
    </div>
    <div class="preview__item">
      <div class="preview__title">
        <p>Datos de la operación</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Fecha</p>
          <p class="preview__info">
            {{ this.utils.getFormattedDate(reservation.audit.createdDate) }}
          </p>
        </div>
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Operación</p>
          <p class="preview__info">{{ reservation.operationTypeName }}</p>
        </div>
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Ticket</p>
          <p class="preview__info">
            {{ currencySymbol }}
            {{ reservation.price | number : "1.0-2" }}
          </p>
        </div>
        <div class="preview__column preview__column--operation-last" >
          <p class="preview__subtitle">Tipo de cambio</p>
          <p class="preview__info" *ifNodeHide="[NODE_EC]">
            $ {{ reservation.exchangeRate | number : "1.0-2" }}
          </p>
          <p class="preview__info" *ifNodeShow="[NODE_EC]">
            -
          </p>
        </div>
      </div>
    </div>
    <!-- DETALLES DE LA RESERVA -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles de la reserva</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--state">
          <p class="preview__subtitle">Estado</p>
          <p class="preview__info" *ifNodeHide="[NODE_PY]">
            {{ this.utils.capitalize(reservation.state.toLowerCase()) }}
          </p>
          <p class="preview__info" *ifNodeShow="[NODE_PY]">
            {{ reservation.stateLabel }}
          </p>
        </div>
        <div class="preview__column preview__column--type">
          <p class="preview__subtitle">Tipo de contrato</p>
          <p
            class="preview__info"
            *ngIf="reservation.captationType !== 'NO_CAPTADO_BUSQUEDA'"
          >
            {{ this.utils.capitalize(reservation.captationType.toLowerCase()) }}
          </p>
          <p
            class="preview__info"
            *ngIf="reservation.captationType === 'NO_CAPTADO_BUSQUEDA'"
          >
            No captado
          </p>
        </div>
        <div class="preview__column preview__column--date-closed">
          <p class="preview__subtitle">Fecha estimada cierre</p>
          <p class="preview__info">
            {{ this.utils.getFormattedDate(reservation.estimateCloseDate) }}
          </p>
        </div>
        <div class="preview__column preview__column--active">
          <p class="preview__subtitle">Activa</p>
          <p class="preview__info">{{ reservation.active ? "Sí" : "No" }}</p>
        </div>
        <div class="preview__column preview__column--shared">
          <p class="preview__subtitle">Compartida al 50%</p>
          <p class="preview__info">{{ reservation.shared ? "Sí" : "No" }}</p>
        </div>
      </div>
    </div>
    <!-- DETALLES DEL AGENTE VENDEDOR -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles del agente {{ NODE === NODE_DO ? 'captador' : 'vendedor' }}</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Nombre</p>
          <p class="preview__info">
            {{ reservation.organizationNameVendedor }}
          </p>
        </div>
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Comisión</p>
          <p
            *ngIf="reservation.percentageComitionVendedor !== null"
            class="preview__info"
          >
            <ng-container
              *ngIf="reservation.percentageComitionVendedor; else noSellPercent"
            >
              {{ reservation.percentageComitionVendedor | number : "1.0-2" }}%
            </ng-container>
            <ng-template #noSellPercent>-</ng-template>
            /
            <ng-container
              *ngIf="reservation.amountComitionVendedor; else noSellTotal"
            >
            {{ currencySymbol }}
            {{ reservation.amountComitionVendedor | number : "1.0-2" }}
            </ng-container>
            <ng-template #noSellTotal>-</ng-template>
          </p>
        </div>
        <div class="preview__column preview__column--agent-last">
          <p class="preview__subtitle">Origen cliente</p>
          <p class="preview__info">
            {{ reservation.saleCustomerOrigin ?? "-" }}
          </p>
        </div>
      </div>
    </div>
    <!-- DETALLES DEL AGENTE COMPRADOR -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles del agente comprador</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Nombre</p>
          <p class="preview__info">
            {{ reservation.organizationNameComprador }}
          </p>
        </div>
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Comisión</p>
          <p class="preview__info">
            <ng-container
              *ngIf="
                reservation.percentageComitionComprador !== null &&
                  reservation.percentageComitionComprador !== undefined;
                else noPercent
              "
            >
              {{ reservation.percentageComitionComprador | number : "1.0-2" }}%
            </ng-container>
            <ng-template #noPercent>-</ng-template>
            /
            <ng-container
              *ngIf="
                reservation.amountComitionComprador !== null &&
                  reservation.amountComitionComprador !== undefined;
                else noTotal
              "
            >
            {{currencySymbol}}
            {{ reservation.amountComitionComprador | number : "1.0-2" }}
            </ng-container>
            <ng-template #noTotal>-</ng-template>
          </p>
        </div>
        <div class="preview__column preview__column--agent-last">
          <p class="preview__subtitle">Origen cliente</p>
          <p class="preview__info">
            {{ reservation.purchaseCustomerOrigin ?? "-" }}
          </p>
        </div>
      </div>
    </div>
    <!-- COMISIÓN OFICINA -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Comisión oficina</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--comission">
          <p class="preview__subtitle">Porcentaje</p>
          <p class="preview__info">
            {{
              reservation.percentageComition
                ? reservation.percentageComition + "%"
                : "-"
            }}
          </p>
        </div>
        <div class="preview__column preview__column--comission-last">
          <p class="preview__subtitle">Monto</p>
          <p class="preview__info">
            {{
              reservation.totalComition ? currencySymbol + ' ' + (reservation.totalComition | number : "1.0-2") : "-"
            }}
          </p>
        </div>
      </div>
    </div>
    <!-- DETALLES -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles</p>
      </div>
      <div class="preview__data--last">
        <div class="preview__column">
          <p class="preview__subtitle">Notas</p>
          <p class="preview__info">
            {{ reservation.notes?.trim() ? reservation.notes : "-" }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="preview__actions">
    <qr-button [config]="buttonGoBack" (click)="closeDialog()"></qr-button>
    <qr-button
      *ngIf="reservation.state !== 'CERRADO'"
      [config]="buttonGenerateClose"
      (click)="generateClose()"
    ></qr-button>
  </div>
</div>
<!-- ------------------------------------------------------------- -->
<!-- ------------------------------------------------------------- -->
<!-- ------------------------------------------------------------- -->
<!-- ------------------------------------------------------------- -->
<!-- ------------------------------------------------------------- -->
<!-- ------------------------------------------------------------- -->
<!-- DETALLE CAPTACIÓN -->
<div class="preview" *ngIf="!isReservation && catchment">
  <div class="preview__container">
    <div class="preview__item">
      <div class="preview__title">
        <p>Propiedad</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--address">
          <p class="preview__subtitle">Dirección</p>
          <p class="preview__info">{{ catchment.address }}</p>
        </div>
        <div class="preview__column preview__column--mls">
          <p class="preview__subtitle">MLS-ID</p>
          <p class="preview__info">{{ catchment.mlsId }}</p>
        </div>
      </div>
    </div>
    <div class="preview__item">
      <div class="preview__title">
        <p>Datos de la operación</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Fecha</p>
          <p class="preview__info">
            {{ this.utils.getFormattedDate(catchment.audit.createdDate) }}
          </p>
        </div>
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Operación</p>
          <p class="preview__info">{{ catchment.operationTypeName }}</p>
        </div>
        <div class="preview__column preview__column--operation">
          <p class="preview__subtitle">Ticket</p>
          <p class="preview__info">
            {{ currencySymbol }}
            {{ catchment.price | number : "1.0-2" }}
          </p>
        </div>
        <div class="preview__column preview__column--operation-last">
          <p class="preview__subtitle">Tipo de cambio</p>
          <p class="preview__info" *ifNodeHide="[NODE_EC]">
            $ {{ catchment.exchangeRate | number : "1.0-2" }}
          </p>
          <p class="preview__info" *ifNodeShow="[NODE_EC]">-</p>
        </div>
      </div>
    </div>
    <!-- DETALLES DEL AGENTE VENDEDOR -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Datos del agente captador</p>
      </div>
      <div class="preview__data">
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Agente captador</p>
          <p class="preview__info">{{ catchment.organizationNameVendedor }}</p>
        </div>
        <div class="preview__column preview__column--agent">
          <p class="preview__subtitle">Comisión</p>
          <!-- Compartida -->
          <p class="preview__info">
            {{ catchment.percentageComition | number : "1.0-2" }}% / ${{
              catchment.totalComition | number : "1.0-2"
            }}
          </p>
        </div>
        <div class="preview__column preview__column--agent-last">
          <p class="preview__subtitle">Origen cliente</p>
          <p class="preview__info">{{ catchment.saleCustomerOrigin ?? "-" }}</p>
        </div>
      </div>
    </div>
    <!-- DETALLES DE LA OPERACIÓN -->
    <div class="preview__item">
      <div class="preview__title">
        <p>Detalles</p>
      </div>
      <div class="preview__data--last">
        <div class="preview__column preview__column--state-catchment">
          <p class="preview__subtitle">Estado</p>
          <p class="preview__info">
            {{ catchment.avaible === 1 ? "Activa" : "Inactiva" }}
          </p>
        </div>
        <div class="preview__column preview__column--type-operation">
          <p class="preview__subtitle">Tipo de contrato</p>
          <p class="preview__info">
            {{ this.utils.capitalize(catchment.captationType.toLowerCase()) }}
          </p>
        </div>
        <div class="preview__column">
          <p class="preview__subtitle">Notas</p>
          <p class="preview__info-notes">
            {{ catchment.notes?.trim() ? catchment.notes : "-" }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="preview__actions">
    <qr-button [config]="buttonGoBack" (click)="closeDialog()"></qr-button>
    <qr-button
      *ngIf="catchment.avaible === 1"
      [config]="buttonGenerateNewReservation"
      (click)="generateClose()"
    ></qr-button>
  </div>
</div>
